import React from "react";
import { SvgIcon } from "@mui/material";
import BarChartIcon from "@mui/icons-material/BarChart";
import AttachMoneyIcon from "@mui/icons-material/AttachMoney";
import PeopleIcon from "@mui/icons-material/People";

/**
 * Sales-specific menu items
 */
export const salesItems = [
  {
    title: "Dashboard",
    path: "/sales/dashboard",
    icon: (
      <SvgIcon fontSize="small">
        <BarChartIcon />
      </SvgIcon>
    ),
  },
  {
    title: "Revenue",
    path: "/sales/revenue",
    icon: (
      <SvgIcon fontSize="small">
        <AttachMoneyIcon />
      </SvgIcon>
    ),
  },
  {
    title: "Customers",
    path: "/sales/customers",
    icon: (
      <SvgIcon fontSize="small">
        <PeopleIcon />
      </SvgIcon>
    ),
  },
  // Add more sales menu items here as needed
];
